import PropTypes from 'prop-types';

export const bankCardProps = PropTypes.shape({
  maskedPan: PropTypes.string,
  id: PropTypes.string,
  recurrent: PropTypes.string,
  isDefault: PropTypes.bool,
});

export const newCardObject = { id: null };

export const MODAL_MODE = {
  ERROR: 'ERROR',
  DELETE: 'DELETE',
};
